<template>
  <div class="authors">
    <SecretElems
      v-if="isLoggedInWp"
      class="authors__secret"
      :article="article"
    />
    <div class="authors__wrapper">
      <ArticleCardPerson :person="article.author" />
    </div>
  </div>
</template>

<script lang="ts">
  import ArticleCardPerson from '~/components/ArticleCard/ArticleCardPerson.vue';
  import { useSingleArticleStore } from '~/store/singleArticle';
  import SecretElems from '~/components/SecretElems.vue';
  import { useUserStore } from '~/features/user/store';
  import { mapState } from 'pinia';

  export default defineNuxtComponent({
    name: 'AuthorsBlock',
    components: {
      ArticleCardPerson,
      SecretElems,
    },

    computed: {
      ...mapState(useUserStore, ['isLoggedInWp']),

      article() {
        return useSingleArticleStore().article;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .authors {
    &__secret {
      margin-bottom: $spacing-7;
      display: flex;
      align-items: center;
    }

    &__secret-elem {
      &:not(:last-child) {
        margin-right: $spacing-2;
      }
    }
  }
</style>
